import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from '../styles';

const Toast = ({ message, type = 'success', onClose }) => {
  React.useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <ToastContainer $type={type}>
      <Message>{message}</Message>
    </ToastContainer>
  );
};

const slideIn = keyframes`
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const ToastContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 1rem 2rem;
  border-radius: 8px;
  background-color: ${props => 
    props.$type === 'error' ? '#ff4d4f' : 
    props.$type === 'success' ? '#52c41a' : 
    colors.secondary};
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: ${slideIn} 0.3s ease;
  z-index: 1000;
`;

const Message = styled.p`
  margin: 0;
  font-family: 'Indie Flower', cursive;
  font-size: 1.1rem;
`;

export default Toast; 